import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

const store = new Vuex.Store({

  state: {
    menu: [],
    show_menu:0,
    now_menu:{
      1:0,
      2:0,
      3:0,
    },
    user_info: {},
    base_info_status : false,
    source_host: '',
    product_list: [],
    country_list: [],
    language_list: [],
    push_channel_list: [],
    material_type_list: [],
    material_size_list: [],
    material_image_size_list: [],
    source_image_type_list:[
      {"value":1,"name":"广告图"},
      // {"value":2,"name":"EndCard"},
      {"value":3,"name":"画中画"},
      {"value":4,"name":"ASO"},
      {"value":5,"name":"ICON"},
      {"value":2,"name":"渠道图"},
      {"value":6,"name":"海报图"},
    ],
  },
  mutations: {
    setMenu(state, payload) {
      state.menu = payload
    },
    setShowMenu(state, payload) {
      state.show_menu = payload
    },
    setNowMenu(state, payload) {
      state.now_menu[payload[0]] = payload[1]
    },
    setUserInfo(state, payload) {
      state.user_info = payload
    },
    setBaseInfoStatus(state, payload) {
      state.base_info_status = payload
    },
    setSourceHost(state, payload) {
      state.source_host = payload
    },
    setProductList(state, payload) {
      state.product_list = payload
    },
    setCountryList(state, payload) {
      state.country_list = payload
    },
    setLanguageList(state, payload) {
      state.language_list = payload
    },
    setPushChannelList(state, payload) {
      state.push_channel_list = payload
    },
    setMaterialTypeList(state, payload) {
      state.material_type_list = payload
    },
    setMaterialImageSizeList(state, payload) {
      state.material_image_size_list = payload
    },
    setMaterialSizeList(state, payload) {
      state.material_size_list = payload
    },
  },
  getters: {},
  actions: {},
  modules: {}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js